import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import VisaFormService from "services/VisaFormService";

let initialState = { list: [] };

export const getDigitalWorkpermitList = createAsyncThunk(
  "smartform/getDigitalWorkpermitList",
  async (body) => {
    const response = await VisaFormService.getDigitalWorkpermitList(body);
    return response?.results;
  }
);

const digitalWorkpermitListSlice = createSlice({
  name: "smartform/digitalWorkpermit",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getDigitalWorkpermitList, builder, ["list"]);
  },
});


export const selectDigitalWorkpermitList = (state) => state.digitalWorkpermitList;

export default digitalWorkpermitListSlice.reducer;

